"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSkinnedMesh = void 0;
var realms_three_1 = __importDefault(require("realms-three"));
function isSkinnedMesh(obj) {
    return obj instanceof realms_three_1.default.SkinnedMesh;
}
exports.isSkinnedMesh = isSkinnedMesh;
